import { render, staticRenderFns } from "./EstoqueReservas.vue?vue&type=template&id=345d1107&"
import script from "./EstoqueReservas.vue?vue&type=script&lang=js&"
export * from "./EstoqueReservas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports